import axios from "axios";

document.addEventListener("DOMContentLoaded", function () {
    setCartLogic();
})

function setCartLogic(params) {
    const domEl = {
        wishlistBtns: document.querySelectorAll(".js-wishlist"),
        likeBtns: document.querySelectorAll(".js-like"),
    };

    if(domEl.likeBtns.length) {
        domEl.likeBtns.forEach((element) => {
            element.addEventListener("click", (event) => setLike(event));
        });
    }
    if(domEl.wishlistBtns.length) {
        domEl.wishlistBtns.forEach((element) => {
            element.addEventListener("click", (event) => setWishList(event));
        });
        let countWishList = [];
        let iconCounts = document.querySelectorAll(".js-count-items");

        if(iconCounts.length > 0) {
            let countWishInLocal = parseInt(iconCounts[0].textContent);
            if(countWishInLocal !== countWishList.length) {
                axios.get(`/wishlist/items`).then(function (response) {
                    if(response.data.length) {
                        countWishList = response.data["data"][0]["models"];
                        iconCounts.forEach((count) => {
                            count.textContent = countWishList.length;
                        });
                        element.querySelector("img").src =
                            "/images/icon-lable-full.svg";
                        localStorage.setItem("itemCount", vm.countWishList.length);
                    }
                });
            }
        }

    }
}

async function setLike(event) {
    let autorizetion = event.target
        .closest(".card-model")
        .getAttribute("data-autorizetion");

    if(parseInt(autorizetion) === 0) {
        window.location.href = "/sigh-in";
        return;
    }
    try {
        let parentId = event.target.closest(".card-model").getAttribute("id");
        let url = !event.target.classList.contains("fa-solid")
            ? `/${parentId}/like`
            : `/${parentId}/unlike`;
        const resp = await axios.post(url);
        event.target.classList.toggle("fa-solid");
        if(event.target.classList.contains("fa-solid")) {
            event.target.src = "/images/icons/icon-like-full.svg";
            window.notify(window.getTranslationText("This model added to favorites"), "success");
        } else {
            event.target.src = "/images/icons/icon-like.svg";
            window.notify(window.getTranslationText("This model removed from favorites"), "success");
        }

    } catch (error) {
        window.notify(error.response.data.message, "error");
    }
}

async function setWishList(event) {
    let autorizetion = event.target
        .closest(".card-model")
        .getAttribute("data-autorizetion");

    if(parseInt(autorizetion) === 0) {
        window.location.href = "/sigh-in";
        return;
    }

    if(!event.target.classList.contains("fa-solid")) {
        let productId = event.target.closest(".card-model").getAttribute("id");
        let data = {
            user_id: event.target
                .closest(".card-model")
                .getAttribute("data-userId"),
            model_id: productId,
        };
        try {
            const response = await axios.post(
                `/wishlist/store/${productId}`,
                data
            );
            let itemCount = localStorage.getItem("itemCount");
            if(itemCount) {
                itemCount = parseInt(itemCount) + 1;

            } else {
                itemCount = 1;
            }
            localStorage.setItem("itemCount", itemCount);

            let iconCounts = document.querySelectorAll(".js-count-items");
            iconCounts.forEach((count) => {
                count.textContent = itemCount;
            });
            event.target.src = "/images/icon-lable-full.svg";
            event.target.classList.add("fa-solid");
            window.notify(window.getTranslationText("This model added to wishlist"), "success");
        } catch (error) {
            window.notify(window.getTranslationText("This model not added to wishlist"), "error");
        }
    }
}

export {setCartLogic};

